import React, {PureComponent, Fragment} from 'react';
import uuid from 'uuid/v4';

export default class CheckboxInput extends PureComponent {
  id = uuid()

  render() {
    let {value, children} = this.props;

    return (
      <Fragment>
        <input type="checkbox" checked={value === true} onChange={this._onChange}
            id={`checkbox-${this.id}`} />
        {children && <label htmlFor={`checkbox-${this.id}`}>{children}</label>}
      </Fragment>
    );
  }

  _onChange = (event) => {
    this.props.onChange(event.target.checked);
  }
}


// WEBPACK FOOTER //
// ./src/components/CheckboxInput.js